<div class="data_in" [class.data_in--embedded]="isEmbedded">
  <div class="inbox-container" [class.no-preview]="isEmbedded && !hasDocument" [class.embedded-overlay]="isEmbedded">
    <!-- Full-page route and the inbox in-page overlay (isEmbedded): document
         preview on the left (sized to fit), form on the right. Embedded keeps
         the form in inbox mode (prev/next swap in place via overlayMode) and
         collapses to form-only when there's no document. -->
    <ng-container *ngIf="!isMobileDevice">
      <div class="preview-invoice" *ngIf="isEmbedded ? hasDocument : true">
        <app-upload-document [isHorizontalDirection]=isHorizontalDirection
          (documentUnavailable)="onDocumentUnavailable()"
          *ngIf="isEmbedded || submissionMethod != 6"></app-upload-document>
      </div>
      <div class="form-invoice">
        <div>
          <app-upload-invoice-form [isEditable]="isEditMode" [billsToPayMode]="false"
                                   [hexColorClass]="hexColorClass" [isInboxMode]="true"
                                   [overlayMode]="isEmbedded" [currentInvoiceId]="invoiceId"
                                   (navigateInvoice)="navigateInvoice.emit($event)"
                                   (invoicePublished)="invoicePublished.emit($event)"
                                   (invoiceSaved)="invoiceSaved.emit($event)"
                                   (closeFormOnBillsToPayEvent)="toggleInvoiceSideBar()"
                                   [currentPannel]="currentPannel"
                                   (onDeleteDocument)="onDeleteDocument.emit($event)"> </app-upload-invoice-form>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isMobileDevice">
      <div ngClass="cd_sidebar_main sidenav sidenav-show outside_amo_sidebar">
        <div class="modal_wrapper_back"   ></div>
        <div class="sidenav_in cd_sidebar">
          <div class="form-group">
            <!-- Wired like the desktop form: without overlayMode/currentInvoiceId the form never
                 learns there is a next document, and without navigateInvoice nothing loads it,
                 so publishing on mobile left the published bill on screen. -->
            <app-upload-invoice-form [isEditable]="isEditMode" [billsToPayMode]="false" [isInboxMode]="true" [isInboxMobileMode]="true"
                                     [hexColorClass]="hexColorClass"
                                     [overlayMode]="isEmbedded" [currentInvoiceId]="invoiceId"
                                     (navigateInvoice)="navigateInvoice.emit($event)"
                                     (invoicePublished)="invoicePublished.emit($event)"
                                   (invoiceSaved)="invoiceSaved.emit($event)"
                                     (closeFormOnBillsToPayEvent)="toggleInvoiceSideBar()"
                                     [currentPannel]="currentPannel"
                                     (onDeleteDocument)="onDeleteDocument.emit($event)"> </app-upload-invoice-form>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
